module.exports = __webpack_public_path__ + "static/img/img_logo.22fa5986.png";